import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const Contact = ({ slot }) => {
	const { type, data, layout } = slot[0];

	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={40}
				height={6}
				component={type}
				data={data}
				layout={layout}
			/>

			<Slot
				top={15}
				left={22}
				width={25}
				height={30}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={50}
				left={25}
				width={20}
				height={15}
				component={type}
				data={data}
				layout={layout}
			/>

			<Slot
				top={75}
				left={5}
				width={60}
				height={20}
				component={type}
				data={data}
				layout={layout}
			/>

			<Slot
				top={0}
				left={70}
				width={30}
				height={99}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

Contact.defaultProps = {
	slot: []
}

Contact.propTypes = {
	slot: PropTypes.array,
}

export default Contact;
